export default {
  reprintDate: '补标时间',
  printer: '打印机IP',
  siteDate: '补标发起方/日期',
  device: '扫描设备',
  reprintMethod: '补标方式',
  reprintMethodUpc: 'UPC',
  reprintMethodQr: 'QR'
}
